// extracted by mini-css-extract-plugin
export default {"searchBox":"BlockUser_searchBox__KRrwh"};